"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LOGIN_BUTTON_TEXT = exports.INPUT_PLACEHOLDER = exports.INPUT_LABEL = exports.FORGOT_PASSWORD_BUTTON_TEXT = void 0; // Password Component

var INPUT_LABEL = "Password";
exports.INPUT_LABEL = INPUT_LABEL;
var INPUT_PLACEHOLDER = "Password";
exports.INPUT_PLACEHOLDER = INPUT_PLACEHOLDER;
var FORGOT_PASSWORD_BUTTON_TEXT = "Forgot Password?";
exports.FORGOT_PASSWORD_BUTTON_TEXT = FORGOT_PASSWORD_BUTTON_TEXT;
var LOGIN_BUTTON_TEXT = "Login";
exports.LOGIN_BUTTON_TEXT = LOGIN_BUTTON_TEXT;
var _default = {
  INPUT_LABEL: INPUT_LABEL,
  INPUT_PLACEHOLDER: INPUT_PLACEHOLDER,
  FORGOT_PASSWORD_BUTTON_TEXT: FORGOT_PASSWORD_BUTTON_TEXT,
  LOGIN_BUTTON_TEXT: LOGIN_BUTTON_TEXT
};
exports["default"] = _default;